export * from './account.service';
import { AccountService } from './account.service';
export * from './accountReports.service';
import { AccountReportsService } from './accountReports.service';
export * from './address.service';
import { AddressService } from './address.service';
export * from './admin.service';
import { AdminService } from './admin.service';
export * from './appointment.service';
import { AppointmentService } from './appointment.service';
export * from './auth.service';
import { AuthService } from './auth.service';
export * from './capabilityDefinitions.service';
import { CapabilityDefinitionsService } from './capabilityDefinitions.service';
export * from './categorizationProvider.service';
import { CategorizationProviderService } from './categorizationProvider.service';
export * from './company.service';
import { CompanyService } from './company.service';
export * from './companyDetails.service';
import { CompanyDetailsService } from './companyDetails.service';
export * from './dashboard.service';
import { DashboardService } from './dashboard.service';
export * from './eligibilityReport.service';
import { EligibilityReportService } from './eligibilityReport.service';
export * from './eligibilityReportAttachment.service';
import { EligibilityReportAttachmentService } from './eligibilityReportAttachment.service';
export * from './employee.service';
import { EmployeeService } from './employee.service';
export * from './employer.service';
import { EmployerService } from './employer.service';
export * from './import.service';
import { ImportService } from './import.service';
export * from './kros.service';
import { KrosService } from './kros.service';
export * from './medicalExamination.service';
import { MedicalExaminationService } from './medicalExamination.service';
export * from './medicalExaminationType.service';
import { MedicalExaminationTypeService } from './medicalExaminationType.service';
export * from './occupation.service';
import { OccupationService } from './occupation.service';
export * from './occupationCategorization.service';
import { OccupationCategorizationService } from './occupationCategorization.service';
export * from './order.service';
import { OrderService } from './order.service';
export * from './orderRcmd.service';
import { OrderRcmdService } from './orderRcmd.service';
export * from './payment.service';
import { PaymentService } from './payment.service';
export * from './priceList.service';
import { PriceListService } from './priceList.service';
export * from './provider.service';
import { ProviderService } from './provider.service';
export * from './providerCalendar.service';
import { ProviderCalendarService } from './providerCalendar.service';
export * from './setting.service';
import { SettingService } from './setting.service';
export * from './templates.service';
import { TemplatesService } from './templates.service';
export * from './tenant.service';
import { TenantService } from './tenant.service';
export * from './user.service';
import { UserService } from './user.service';
export * from './workplace.service';
import { WorkplaceService } from './workplace.service';
export const APIS = [AccountService, AccountReportsService, AddressService, AdminService, AppointmentService, AuthService, CapabilityDefinitionsService, CategorizationProviderService, CompanyService, CompanyDetailsService, DashboardService, EligibilityReportService, EligibilityReportAttachmentService, EmployeeService, EmployerService, ImportService, KrosService, MedicalExaminationService, MedicalExaminationTypeService, OccupationService, OccupationCategorizationService, OrderService, OrderRcmdService, PaymentService, PriceListService, ProviderService, ProviderCalendarService, SettingService, TemplatesService, TenantService, UserService, WorkplaceService];
